module.exports = __webpack_public_path__ + "static/media/inbox.511b8d7b.svg";